/**
 * WEB-3739 юнит 1 — баланс кошелька в оболочке кабинета: первая загрузка при
 * монтировании и автообновление (интервал, возврат на вкладку, сигнал соседней
 * вкладки — `useBillingAutoRefresh`, WEB-936 п.5). Монтируется в
 * `router/DashboardLayout.tsx`: меню профиля, где показан остаток, большую часть
 * времени закрыто, а держать срез `billing` свежим нужно и для страниц
 * (история операций обновляется по смене остатка). Прежде это делал виджет
 * шапки `HeaderBalanceWidget` (WEB-382), снятый этим юнитом.
 */
import { useEffect, useRef } from 'react';
import { useAppDispatch } from '@/hooks/hooks';
import { fetchBillingThunk } from '@/store/billingSlice';
import { useBillingAutoRefresh } from '@/hooks/useBillingAutoRefresh';

export function useShellBalance(): void {
  const dispatch = useAppDispatch();
  const fetched = useRef(false);
  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    dispatch(fetchBillingThunk());
  }, [dispatch]);
  useBillingAutoRefresh();
}
